/* eslint-disable react/prop-types */
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { CancelPresentationRounded } from '@mui/icons-material';
import styles from './style';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { REDUX_ACTIONS } from '../../../shared/config/constants';
import { listRigs } from '../../../store/actions/rigs';
import AutocompleteComponent from '../Autocomplete';

const RigsToTargetSelectionDialog = ({ open, handleClose, handleConfirm, data }) => {
  const classes = styles();
  const dispatch = useDispatch();
  const rigs = useSelector((state) => state.rigs);
  const [rignameNumbers, setRignameNumbers] = useState([]);
  const [selectedRigs, setSelectedRigs] = useState([]);

  useEffect(() => {
    if (!rigs.loading && rigs.data.length === 0) {
      dispatch({
        type: REDUX_ACTIONS.RIGS_LIST_LOADING,
      });
      dispatch(listRigs());
    }
    if (Object.keys(data?.rigs || {})?.length > 0) {
      setSelectedRigs(Object.keys(data?.rigs || {}));
    }
  }, []);

  useEffect(() => {
    if (!rigs.loading && rigs?.data?.length) {
      const uniqueRigNames = [
        ...new Set(
          rigs?.data
            .map(item => item.RigName_Number)
            .filter(Boolean)
        )
      ];
      setRignameNumbers(uniqueRigNames);
    }
  }, [rigs.loading]);

  return (
        <Dialog
            open={open}
             onClose={(event, reason) => {
               if (reason === 'backdropClick') {
                 return;
               }
               handleClose();
             }}
            fullWidth={true}
            className={classes.dialogModal}
        >
            <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>Rigs to Target</Grid>
                        <Grid item>
                            <IconButton
                                onClick={() => {
                                  handleClose(false);
                                }}
                            >
                                <CancelPresentationRounded fontSize='large' />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Typography>
            </Box>
            <Divider />
          <DialogContent style={{ marginTop: '2px' }}>
              <Grid sx={{ width: '100%' }}>
                  <AutocompleteComponent
                      title={'Rigs'}
                      data={selectedRigs}
                      options={rignameNumbers}
                      onChange={(event, values) => {
                        setSelectedRigs([...values]);
                      }}
                      hideHeader
                      loading={rigs?.loading}
                  />
              </Grid>
          </DialogContent>
            <Grid container item justifyContent='center' marginBottom='2rem'>
                <DialogActions>
                    <Button
                        className={classes.button}
                        onClick={() => {
                          const rigsPayloadObject = rigs?.data
                            .filter(rig => selectedRigs.includes(rig.RigName_Number))
                            .reduce((acc, rig) => {
                              acc[rig?.RigName_Number] = [
                                rig.RigLatitudeWGS84,
                                rig.RigLongitudeWGS84
                              ];
                              return acc;
                            }, {});
                          handleConfirm(data, rigsPayloadObject);
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
  );
};

RigsToTargetSelectionDialog.propTypes = {
  open: PropTypes.any,
  handleClose: PropTypes.any,
  confirmationText: PropTypes.string,
  handleConfirm: PropTypes.func,
  data: PropTypes.any
};

export default RigsToTargetSelectionDialog;
